<!-- campaign-container -->
<div class="upsell-campaign dialog-body" *ngIf="campaignType === 'promotional'">

  <!-- campaign-left-container -->
  <div class="ui-g-6 bg-promotional-left padding-left-campaign">
    <div class="conversation-tile flex-start-start" *ngFor="let propmotional of campaignPropmotional">
      <div class="initials-wrapper">
        <img src={{propmotional.src}} alt="" class="frame" />
      </div>

      <div class="conversation-tile-right">
        <div class="flex-row flex-between mb-1">
          <div class="title">
            {{propmotional.title}}
          </div>
        </div>

        <div class="flex-row flex-between flex-center">
          <div class="description">
            <span>{{propmotional.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- campaign-right-container -->
  <div class="ui-g-6 bg-promotional-right">
    <div class=" p-zero dialog-header mb-2">
      <div class="flex-end-center">
        <div class="width-45 pt-3 pr-2 pointer">
          <i id="close-dialog-icon" class="fal fa-times fa-sm ml-15 dialog-close font-18" (click)="close()"></i>
        </div>
      </div>
    </div>
    <div class="marketing-section">
      <div class="marketing-trial-version mb-3">Marketing trial version</div>
      <div class="marketing-heading font-black mb-3">Grow your business using
        <span class="font-green">
          Promotional campaigns!
        </span>
      </div>

      <div class="promotinal-text mt-2 mb-3">
        <span class="" *ngIf="remainingCount.usedPromotions === 1 && !showSubscribeText">
          Upsell your products and services, engage with customers during major events and entice customers towards your
          business with discounts and deals!
        </span>
        <span class="" *ngIf="remainingCount.usedPromotions === 1 && showSubscribeText">
          You have run out of free promotional campaigns. Subscribe to AutoLeap Marketing and gain access to unlimited campaigns.
        </span>
        <!-- for future use if promotionLimit > 1 -->
        <!-- <span class="" *ngIf="remainingCount.promotionLimit  === remainingCount.promotionLimit">
              Upsell your products and services, engage with customers during major events and entice customers towards your business with discounts and deals!
            </span> -->

      </div>

      <!-- for future use if promotionLimit > 1 -->
      <!-- <div class="progress mt-4 mb-4">
        <div class="progress-bar"   [ngStyle]="{'width': progressPercentage(remainingCount?.promotionLimit, remainingCount?.usedPromotions) }">
          <div class="progress-value">{{remainingCount.usedPromotions || 0}}/{{remainingCount?.promotionLimit || 0}} used</div>
      </div>
      </div> -->

      <div class="button mt-2 pointer" (click)="showIntercom()">
        <span class="send">
          Get unlimited access
        </span>
      </div>
    </div>


  </div>
</div>


<!-- followup-container -->
<div class="upsell-campaign dialog-body" *ngIf="campaignType === 'followup'">

  <!-- followup-left-container -->
  <div class="ui-g-6 bg-followup-left padding-left-followup">
    <div class="conversation-tile flex-start-start" *ngFor="let followup of campaignFollowup">
      <div class="initials-wrapper">
        <img src={{followup.src}} alt="" class="frame" />
      </div>

      <div class="conversation-tile-right">
        <div class="flex-row flex-between mb-1">
          <div class="title">
            {{followup.title}}
          </div>
        </div>

        <div class="flex-row flex-between flex-center">
          <div class="description">
            <span>{{followup.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- followup-right-container -->
  <div class="ui-g-6 bg-followup-right">
    <div class=" p-zero dialog-header mb-2">
      <div class="flex-end-center">
        <div class="width-45 pt-3 pr-2 pointer">
          <i id="close-dialog-icon" class="fal fa-times fa-sm ml-15 dialog-close font-18" (click)="close()"></i>
        </div>
      </div>
    </div>

    <div class="marketing-section">
      <div class="marketing-trial-version mb-3">Marketing trial version</div>

      <div class="marketing-heading font-black" *ngIf="remainingCount.usedFollowUps === 1">Great work scheduling your <br>
        <span class="font-green">
          1st Follow-up
        </span>
      </div>

      <div class="marketing-heading font-black"
        *ngIf="remainingCount.usedFollowUps > 1 && remainingCount.usedFollowUps < remainingCount.followUpLimit">Use
        <span class="font-green">
          Follow-ups
        </span>
        to increase customer retention
      </div>

      <div class="marketing-heading font-black mb-3" *ngIf=" remainingCount.usedFollowUps >= remainingCount.followUpLimit">
        You have successfully scheduled <br>
        <span class="font-green">
          {{remainingCount.followUpLimit}} Follow-ups
        </span>
      </div>

      <div class="promotinal-text mt-2">
        <span class="" *ngIf="remainingCount.usedFollowUps === 1">
          Supercharge your business by leveraging your existent customer base!
        </span>

        <span class="" *ngIf="remainingCount.usedFollowUps > 1 && remainingCount.usedFollowUps < remainingCount.followUpLimit">
          Repeat customers are willing on average to spend more per repair order, visit more often and are more likely
          to refer friends and family.
        </span>

        <span class="" *ngIf="remainingCount.usedFollowUps >= remainingCount.followUpLimit">
          Turn 1 time visitors into lifetime customers! Subscribe to Autoleap Marketing to elevate your business today!
        </span>
      </div>

      <div class="progress mt-4 mb-4">
        <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="14"
          [ngStyle]="{'width':  progressPercentage(remainingCount?.followUpLimit, remainingCount?.usedFollowUps) }">
          <div class="progress-value" *ngIf="remainingCount.usedFollowUps !== 0">{{remainingCount.usedFollowUps || 0}}/{{remainingCount.followUpLimit || 0}} used</div>
        </div>
      </div>

      <div class="subscribe-followup mt-2 mb-3 font-black font-14 font-600" *ngIf=" remainingCount.usedFollowUps >= remainingCount.followUpLimit">
        Subscribe now to
        <span class="font-green font-14 font-600">AutoLeap Marketing</span>
      </div>


      <div class="button mt-2 pointer" (click)="showIntercom()">
        <span class="send">
          Get unlimited access
        </span>
      </div>
    </div>


  </div>
</div>
